import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ListFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M7.22 6.3C7.22 7.18 6.5 7.9 5.62 7.9C4.74 7.9 4.02 7.18 4.02 6.3C4.02 5.42 4.74 4.7 5.62 4.7C6.5 4.7 7.22 5.42 7.22 6.3ZM9.04 7.22V5.38H19.48V7.22H9.04ZM7.22 11.96C7.22 12.84 6.5 13.56 5.62 13.56C4.74 13.56 4.02 12.84 4.02 11.96C4.02 11.08 4.74 10.36 5.62 10.36C6.5 10.36 7.22 11.08 7.22 11.96ZM9.04 12.88V11.04H19.48V12.88H9.04ZM7.22 17.62C7.22 18.5 6.5 19.22 5.62 19.22C4.74 19.22 4.02 18.5 4.02 17.62C4.02 16.74 4.74 16.02 5.62 16.02C6.5 16.02 7.22 16.74 7.22 17.62ZM9.04 18.54V16.7H19.48V18.54H9.04Z" />
    </SvgIcon>
  );
});
